import React, { useEffect, useState } from 'react'

export const FortySecondProgressBar = ({
  onComplete,
}: {
  onComplete?: () => void
}) => {
  const DURATION = 40000 // 40초
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const intervalTime = 100
    const increment = (100 / DURATION) * intervalTime

    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment
        if (next >= 100) {
          clearInterval(interval)
          onComplete?.() // 40초 뒤 콜백 실행
          return 100
        }
        return next
      })
    }, intervalTime)

    return () => clearInterval(interval)
  }, [onComplete])

  return (
    <div className="w-full h-4 bg-gray-300 rounded-full overflow-hidden">
      <div
        className="h-full bg-main transition-all duration-100"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
